import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Row, Col, Card, Table, Button, Form, InputGroup, Badge, Spinner, Dropdown } from 'react-bootstrap';
import { getApiUrl } from '../config/api';

const GroupUser = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [username, setUsername] = useState('Administrator');
  const [menus, setMenus] = useState([]);
  const [isNavOpen, setIsNavOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [activeMenu, setActiveMenu] = useState('');
  const [time, setTime] = useState({ date: '', clock: '' });

  // ==========================================
  // STATE GROUP USER DATA
  // ==========================================
  const [groups, setGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fetchError, setFetchError] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  // ==========================================
  // EFFECTS
  // ==========================================
  useEffect(() => {
    const savedUser = localStorage.getItem('nama_user') || localStorage.getItem('user');
    if (savedUser) setUsername(savedUser);

    const savedMenu = localStorage.getItem('mainmenu');
    if (savedMenu) {
      const parsedMenu = JSON.parse(savedMenu);
      setMenus(parsedMenu);
      if (parsedMenu.length > 0) setActiveMenu(parsedMenu[0].id_mn);
    }

    const updateTime = () => {
      const now = new Date();
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      setTime({
        date: now.toLocaleDateString('id-ID', options),
        clock: now.toLocaleTimeString('id-ID') + ' WIB'
      });
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchGroups();
  }, []);

  // ==========================================
  // FETCH DATA GROUPS
  // ==========================================
  const fetchGroups = async () => {
    setIsLoading(true);
    setFetchError('');
    try {
      const token = localStorage.getItem('token');
      const apiUrl = getApiUrl();
      const response = await fetch(`${apiUrl}/show_group?token=${encodeURIComponent(token)}`);
      if (!response.ok) throw new Error(`Server error: ${response.status}`);
      const json = await response.json();
      setGroups(json.list_group || json.data || []);
    } catch (err) {
      setFetchError('Gagal mengambil data group: ' + err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getMenuIcon = (menuName) => {
    switch (menuName.toUpperCase()) {
      case 'MASTER':        return 'bi-folder2-open';
      case 'GUDANG':        return 'bi-box-seam';
      case 'ADM GUDANG':    return 'bi-building-gear';
      case 'APOTEKER':      return 'bi-prescription2';
      case 'ADMINISTRATOR': return 'bi-person-workspace';
      case 'SETTING':       return 'bi-sliders';
      default:              return 'bi-grid-1x2';
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  // Filter groups berdasarkan query pencarian
  const filteredGroups = groups.filter((g) => {
    const q = searchQuery.toLowerCase().trim();
    if (!q) return true;
    return (
      (g.kode && g.kode.toLowerCase().includes(q)) ||
      (g.nama && g.nama.toLowerCase().includes(q)) ||
      (g.keterangan && g.keterangan.toLowerCase().includes(q))
    );
  });

  return (
    <div style={styles.appContainer}>

      {/* ══════════════ NAVBAR ══════════════ */}
      <nav className="navbar navbar-expand-xl navbar-dark shadow-sm" style={styles.navbarCustom}>
        <Container fluid>
          <a
            className="navbar-brand d-flex align-items-center me-3"
            href="#home"
            style={{ cursor: 'pointer', textDecoration: 'none' }}
          >
            <div className="d-flex align-items-center justify-content-center me-2 rounded-3 p-1"
              style={{ background: 'rgba(255, 255, 255, 0.1)', border: '1px solid rgba(255, 255, 255, 0.15)' }}>
              <i className="bi bi-hospital text-warning fs-5"></i>
            </div>
            <div>
              <div className="fw-bold text-white lh-1" style={{ fontSize: '0.95rem', letterSpacing: '0.3px' }}>
                SIMRS2 <span style={{ color: '#2dd4bf', fontWeight: 500, fontSize: '0.8rem' }}>Finance</span>
              </div>
              <div className="text-white-50 small" style={{ fontSize: '0.65rem' }}>Sistem Informasi Management Rumah Sakit</div>
            </div>
          </a>

                    <button 
            className="navbar-toggler" 
            type="button" 
            onClick={() => setIsNavOpen(!isNavOpen)}
            style={{ border: 'none', outline: 'none' }}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 flex-row gap-2">
              {menus.map((item) => {
                const isActive = location.pathname === item.lnk;
                return (
                  <li className="nav-item" key={item.id_mn}>
                    <a
                      className={`nav-link-custom ${isActive ? 'active' : ''}`}
                      href={`#${item.des_mn.toLowerCase().replace(/\s+/g, '-')}`}
                      onClick={() => { setActiveMenu(item.id_mn); setIsNavOpen(false); }}
                      style={{ ...styles.navLinkCustom, ...(isActive ? styles.navLinkActive : {}) }}
                    >
                      <i className={`bi ${getMenuIcon(item.des_mn)}`}></i>
                      {item.des_mn.toLowerCase().replace(/\b\w/g, s => s.toUpperCase())}
                    </a>
                  </li>
                );
              })}
            </ul>

            <div className="d-flex align-items-center text-white text-end gap-3 ms-auto">
              <div className="small border-end pe-3 border-light border-opacity-25 d-none d-sm-block">
                <div className="fw-semibold" style={{ fontSize: '0.8rem' }}>{time.date}</div>
                <div className="text-warning" style={{ fontSize: '0.7rem' }}>{time.clock}</div>
              </div>

              <Dropdown align="end">
                <Dropdown.Toggle
                  as="div" role="button"
                  className="d-flex align-items-center gap-2 px-2 py-1 rounded-3 custom-profile-toggle"
                  style={{ cursor: 'pointer', transition: 'background-color 0.2s' }}
                >
                  <div
                    className="d-flex align-items-center justify-content-center bg-warning text-dark fw-bold rounded-circle shadow-sm"
                    style={{ width: '32px', height: '32px', fontSize: '0.85rem' }}
                  >
                    {username ? username.charAt(0).toUpperCase() : 'A'}
                  </div>
                  <div className="d-none d-md-block text-start">
                    <div className="text-white fw-semibold lh-1" style={{ fontSize: '0.85rem' }}>{username}</div>
                    <div className="text-white-50 mt-1" style={{ fontSize: '0.7rem' }}>Online</div>
                  </div>
                  <i className="bi bi-chevron-down text-white-50 ms-1 small"></i>
                </Dropdown.Toggle>

                <Dropdown.Menu className="shadow border-0 mt-2 py-2 style-dropdown-menu" style={{ minWidth: '180px', borderRadius: '10px' }}>
                  <Dropdown.Item onClick={handleLogout} className="py-2 text-danger small d-flex align-items-center gap-2 fw-semibold">
                    <i className="bi bi-box-arrow-right"></i> Keluar Aplikasi
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </Container>
      </nav>

      {/* ══════════════ MAIN CONTENT ══════════════ */}
      <div style={styles.mainContent}>
        <Row className="g-3">
          <Col lg={12}>
            <Card style={styles.mainCard}>

              {/* Card Header */}
              <Card.Header style={{ ...styles.cardHeader, ...styles.bgMenuHeader }} className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                <div className="d-flex align-items-center gap-2">
                  <i className="bi bi-collection-fill"></i>
                  <span>GROUP USER</span>
                  {location.state?.info && (
                    <span style={{
                      fontSize: '0.68rem',
                      fontWeight: 400,
                      color: 'rgba(255,255,255,0.75)',
                      background: 'rgba(255,255,255,0.1)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: '20px',
                      padding: '1px 10px',
                    }}>
                      <i className="bi bi-info-circle me-1"></i>{location.state.info}
                    </span>
                  )}
                </div>

                <div className="d-flex align-items-center gap-2">
                  <span className="badge rounded-pill fw-normal px-2" style={{ background: 'rgba(255,255,255,0.15)', fontSize: '0.7rem' }}>
                    {filteredGroups.length} Group
                  </span>
                  <button
                    type="button"
                    className="btn btn-outline-light btn-sm d-inline-flex align-items-center gap-1 fw-semibold shadow-sm ms-2"
                    onClick={() => navigate('/home')}
                    style={styles.actionBtn}
                  >
                    <i className="bi bi-house-door"></i><span>Home</span>
                  </button>
                </div>
              </Card.Header>

              <Card.Body style={{ padding: '1rem' }}>
                {/* Toolbar */}
                <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
                  <InputGroup size="sm" style={{ maxWidth: '320px' }}>
                    <InputGroup.Text style={{ background: '#f1f5f9', border: '1px solid #e2e8f0', color: '#64748b' }}>
                      <i className="bi bi-search" style={{ fontSize: '0.75rem' }}></i>
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Cari kode, nama, keterangan group..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{ fontSize: '0.8rem', border: '1px solid #e2e8f0', borderLeft: 'none' }}
                    />
                    {searchQuery && (
                      <Button variant="outline-secondary" size="sm" onClick={() => setSearchQuery('')} style={{ fontSize: '0.7rem', padding: '0.2rem 0.5rem' }}>
                        <i className="bi bi-x-lg"></i>
                      </Button>
                    )}
                  </InputGroup>

                  <div className="d-flex gap-2">
                    <Button size="sm" variant="outline-secondary" onClick={fetchGroups} disabled={isLoading}
                      style={{ fontSize: '0.75rem' }}>
                      <i className={`bi bi-arrow-clockwise me-1 ${isLoading ? 'spin' : ''}`}></i>
                      Refresh
                    </Button>
                  </div>
                </div>

                {/* Error Banner */}
                {fetchError && (
                  <div className="alert alert-danger d-flex align-items-center gap-2 py-2 mb-3" style={{ fontSize: '0.8rem' }}>
                    <i className="bi bi-exclamation-triangle-fill"></i>
                    <span>{fetchError}</span>
                    <button className="btn btn-sm btn-outline-danger ms-auto" onClick={fetchGroups} style={{ fontSize: '0.7rem' }}>
                      Coba Lagi
                    </button>
                  </div>
                )}

                {/* Table */}
                <div className="table-responsive rounded-2 border" style={{ maxHeight: '60vh' }}>
                  <Table responsive hover size="sm" className="align-middle mb-0" style={{ fontSize: '0.78rem' }}>
                    <thead className="sticky-top" style={{ zIndex: 10 }}>
                      <tr style={{
                        background: 'linear-gradient(180deg, #f8fafc 0%, #e2e8f0 100%)',
                        color: '#0f172a',
                        fontSize: '0.8rem',
                        fontWeight: '800',
                        letterSpacing: '0.5px',
                        borderBottom: '3px solid #0d9488',
                        textTransform: 'uppercase',
                        boxShadow: '0 2px 8px rgba(15, 23, 42, 0.05)'
                      }}>
                        <th className="px-3 py-3 text-center" style={{ color: '#475569', width: '55px', borderRight: '1px solid #cbd5e1' }}>No</th>
                        <th className="px-3 py-3 text-center" style={{ color: '#0284c7', width: '130px', borderRight: '1px solid #cbd5e1' }}>
                          <i className="bi bi-shield-lock-fill me-1 text-primary"></i>Kode Group
                        </th>
                        <th className="px-3 py-3" style={{ color: '#0f172a', minWidth: '220px', borderRight: '1px solid #cbd5e1' }}>
                          <i className="bi bi-people-fill me-1 text-teal"></i>Nama Group Akses
                        </th>
                        <th className="px-3 py-3" style={{ color: '#334155', borderRight: '1px solid #cbd5e1' }}>
                          <i className="bi bi-info-circle-fill me-1 text-info"></i>Keterangan Deskripsi
                        </th>
                        <th className="px-3 py-3 text-center" style={{ color: '#0f172a', width: '110px' }}>
                          <i className="bi bi-check-circle-fill me-1 text-success"></i>Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading ? (
                        <tr>
                          <td colSpan="5" className="text-center py-5 text-muted">
                            <Spinner animation="border" size="sm" className="me-2" style={{ color: '#0d9488' }} />
                            Memuat data group user...
                          </td>
                        </tr>
                      ) : filteredGroups.length === 0 ? (
                        <tr>
                          <td colSpan="5" className="text-center py-5 text-muted">
                            <i className="bi bi-inbox fs-3 d-block mb-1 text-secondary opacity-50"></i>
                            {searchQuery ? 'Tidak ada group user yang cocok dengan kata kunci.' : 'Belum ada data group user.'}
                          </td>
                        </tr>
                      ) : (
                        filteredGroups.map((g, idx) => (
                          <tr key={g.kode || idx} style={{ transition: 'background 0.15s' }}>
                            <td className="px-3 py-2 text-center text-muted">{idx + 1}</td>
                            <td className="px-3 py-2">
                              <Badge style={{ background: '#fef3c7', color: '#b45309', fontSize: '0.68rem', border: '1px solid #fde68a', fontWeight: 600 }}>
                                {g.kode}
                              </Badge>
                            </td>
                            <td className="px-3 py-2 fw-semibold text-dark">
                              <i className="bi bi-people-fill text-teal me-2 opacity-75"></i>
                              {g.nama}
                            </td>
                            <td className="px-3 py-2 text-secondary">
                              {g.keterangan ? g.keterangan : <span className="text-muted fst-italic">—</span>}
                            </td>
                            <td className="px-3 py-2 text-center">
                              <Badge style={{ background: '#dcfce7', color: '#15803d', fontSize: '0.65rem', border: '1px solid #86efac' }}>
                                Aktif
                              </Badge>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </div>

                {/* Footer Info */}
                <div className="d-flex justify-content-between align-items-center mt-2 px-1 text-muted small" style={{ fontSize: '0.72rem' }}>
                  <span>Menampilkan <strong>{filteredGroups.length}</strong> dari <strong>{groups.length}</strong> group user</span>
                  <span>Terakhir diperbarui: {time.clock}</span>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

// ══════════════ STYLES ══════════════
const styles = {
  appContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 40%, #e2e8f0 100%)',
    display: 'flex',
    flexDirection: 'column',
  },
  navbarCustom: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)',
    padding: '0.4rem 1rem',
    flexShrink: 0,
  },
  navLinkCustom: {
    color: 'rgba(255,255,255,0.75)',
    fontSize: '0.78rem',
    fontWeight: 500,
    padding: '0.3rem 0.6rem',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    gap: '0.3rem',
    textDecoration: 'none',
    transition: 'all 0.2s',
  },
  navLinkActive: {
    color: '#ffffff',
    background: 'rgba(255,255,255,0.12)',
  },
  mainContent: {
    flex: 1,
    padding: '0.8rem',
    overflowY: 'auto',
  },
  mainCard: {
    borderRadius: '14px',
    border: '1px solid #cbd5e1',
    boxShadow: '0 10px 30px -5px rgba(15, 23, 42, 0.08), 0 0 15px rgba(13, 148, 136, 0.04)',
    background: '#ffffff',
    overflow: 'hidden',
  },
  cardHeader: {
    padding: '0.65rem 1rem',
    color: '#ffffff',
    fontWeight: 600,
    fontSize: '0.85rem',
  },
  bgMenuHeader: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0d9488 100%)',
  },
  actionBtn: {
    fontSize: '0.73rem',
    borderRadius: '6px',
    border: '1px solid rgba(255,255,255,0.3)',
    padding: '0.25rem 0.6rem',
  },
};

export default GroupUser;


